export default __webpack_public_path__ + "static/media/sticker-pa.a45064b6.png";